import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Industry = () => {
  const { t, i18n } = useTranslation();

  return (
    <Box sx={{ textAlign: "center", pt: 10, width: 1, pb: 20 }}>
      <Typography variant="h4">{t("Industry")}</Typography>
      <Typography
        sx={{
          width: 1 / 2,
          marginLeft: "auto",
          marginRight: "auto",
          pt: 1,
          lineHeight: "2.2em",
        }}
      >
        {t("Industry2")}
      </Typography>
      {/* <Box sx={{ display: { md: "inline-block", sm: "none", xs: "none" } }}>
        <Box
          sx={{
            width: 1,
            display: "flex",
            justifyContent: "center",
            pt: 6,
          }}
        >
          <Box
            sx={{
              backgroundImage: `url("img/gragh3_non.png")`,
              backgroundSize: { md: "750px 300px" },
              backgroundRepeat: "none",
              width: { md: "750px" },
              height: "300px",
            }}
          >
            <Box sx={{ display: "flex" }}>
              <Box
                sx={{
                  width: 1 / 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Box
                  sx={{
                    paddingTop: "45px",
                    paddingLeft: "150px",
                    lineHeight: "1.5em",
                  }}
                >
                  <Typography
                    dangerouslySetInnerHTML={{ __html: t("Industry3") }}
                  />
                </Box>
                <Box
                  sx={{
                    paddingLeft: "38px",
                    paddingTop: "135px",
                    lineHeight: "1.3em",
                  }}
                >
                  <Typography
                    dangerouslySetInnerHTML={{ __html: t("Industry4") }}
                  />
                </Box>
                <Box
                  sx={{
                    paddingLeft: "238px",
                    position: "relative",
                    top: "-35px",
                  }}
                >
                  <Typography
                    dangerouslySetInnerHTML={{ __html: t("Industry5") }}
                  />
                </Box>
              </Box>
              <Box sx={{ width: 1 / 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    paddingTop: "142px",
                    // color: "white",
                    paddingLeft: "13px",
                  }}
                >
                  <Box sx={{ paddingLeft: "27px", color: "white" }}>
                    <Typography
                      dangerouslySetInnerHTML={{ __html: t("Industry6") }}
                    />
                  </Box>
                  <Box
                    sx={{
                      paddingLeft: "112px",
                      color: "white",
                      position: "relative",
                      top: "-2px",
                    }}
                  >
                    {t("sourcing14")}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box> */}
      <Box sx={{ pt: 2 }}>
        {i18n.language === "en" ? (
          <img src="/img/industry_en.jpeg" style={{ width: "70%" }} />
        ) : (
          <img src="/img/industry_ko.jpeg" style={{ width: "70%" }} />
        )}
      </Box>
    </Box>
  );
};

export default Industry;
